module.exports = __webpack_public_path__ + "img/strike-red.853f83c0.svg";